import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'
import Circle from 'components/common/Circle/Circle'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import { OE_CAME_WITH_VEHICLE } from '../../constants'

const OEFilterButton = ({ handleClick, oeCount, className }) =>
  <OEButton
    className={ className }
    secondary
    narrow
    full="mobile"
    onClick={ handleClick }>
    { OE_CAME_WITH_VEHICLE }
    <CircleIcon>
      <Count>
        { oeCount }
      </Count>
    </CircleIcon>
  </OEButton>


OEFilterButton.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  oeCount: PropTypes.number
}

export default OEFilterButton

const OEButton = styled(Button)`
  padding: 5px 24px 4px;
`

const CircleIcon = styled(Circle)`
  display: inline-block;
  position: relative;
  top: -1px;
  width: 20px;
  height: 18px;
  padding: 0;
  margin-left: 6px;
  color: ${Theme.colors.bright_red_new};
  background-color: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.bright_red_new};
  vertical-align: middle;
`

const Count = styled.span`
  display: inline-block;
  position: relative;
  top: 2px;
  ${Mixin.font.GothamBold(12)}
`
